import React, { forwardRef, useImperativeHandle, useRef } from "react";
import { Box, Typography } from "@mui/material";

import ToolbarWithSave, { ToolbarWithSaveHandle } from "../../components/Toolbar/ToolbarWithSave";



interface CenteredCardProps {
    title?: string;
    isLoading: boolean;
    handleSave?: () => Promise<void>;
    handleCancel?: () => void;
    hasChanges?: boolean;
    children: React.ReactNode;
    fullWidth?: boolean | null;
}

const CenteredCard = forwardRef<ToolbarWithSaveHandle, CenteredCardProps>(
    ({ title = "No Title", handleSave, handleCancel, isLoading, hasChanges = false, children, fullWidth }, ref) => {
        const toolbarRef = useRef<ToolbarWithSaveHandle>(null);

        useImperativeHandle(ref, () => ({
            showHasChangesError() {
                toolbarRef.current?.showHasChangesError();
            }
        }));


        return (

            <Box sx={{ padding: "0px 16px 16px 16px", position: "relative", width: "100%" }}>
                {(handleSave || handleCancel) && (
                    <ToolbarWithSave
                        ref={toolbarRef}
                        onSave={handleSave}
                        onCancel={handleCancel}
                        isSaving={isLoading}
                        hasChanges={hasChanges}
                    />
                )}

                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "flex-start",
                        minHeight: "100vh",
                        py: 0,
                        px: 2,
                        backgroundColor: "background.default"
                    }}
                >
                    <Box
                        sx={{
                            width: "100%",
                            maxWidth: { md: fullWidth ? "100%" : "900px" },
                            backgroundColor: "background.paper",
                            padding: 3,
                            borderRadius: { xs: 0, md: 2 },
                            boxShadow: { xs: "none", md: 3 },
                        }}
                    >
                        <Typography variant="h4" sx={{ mb: 2, textAlign: "center", wordBreak: "break-all" }}>
                            {title}
                        </Typography>
                        {children}
                    </Box>
                </Box>
            </Box>
        );
    }
);

export default CenteredCard;
